import { render, staticRenderFns } from "./BookingsNavPlayer.vue?vue&type=template&id=37581722&"
import script from "./BookingsNavPlayer.vue?vue&type=script&lang=js&"
export * from "./BookingsNavPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports